import moduleTemplate from './moduleTemplate'
import serviceWorksApi from '@/api/service-works'

const template = moduleTemplate(serviceWorksApi)
template.types = {
  ...template.types,
  setItems: 'setSearchText'
}
template.mutations = {
  ...template.mutations,
  [template.types.setSearchText] (state, value) {
    state.searchText = value
  }
}

template.actions = {
  ...template.actions,
  updateItem ({ state, commit, dispatch }, params) {
    serviceWorksApi.updateItem(params)
  }
}

export default template
